import React, { useState } from "react";
import PropTypes from "prop-types";
import SmtpManagement from "../../../components/siteadmin/SmtpManagement/SmtpManagement";

function SmtpSetup(props) {

    const [stateVariable, setStateVariable] = useState({
        currentPage: 1,
        searchList: ''
    });

    return <SmtpManagement
        currentPage={stateVariable?.currentPage}
        searchList={stateVariable?.searchList}
        setStateVariable={setStateVariable}
    />
}

SmtpSetup.propTypes = {
    data: PropTypes.shape({
        loading: PropTypes.bool
    })
}

SmtpSetup.defaultProps = {
    data: {
        loading: true
    }
}

export default SmtpSetup;